export default __webpack_public_path__ + "static/guide-poster-04e94bd58bbcc15a6027bb56b56859df.png";